import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ArrowUpLeftIcon = function (_a) {
    var size = _a.size;
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("line", { x1: "20", y1: "20", x2: "5", y2: "5" }), _jsx("polyline", { points: "5 20 5 5 20 5" })] }));
};
